import React from "react";
import moment from "moment";
import swal from "sweetalert";

import View from "./view";

import satisfactionQuestions from "../../../screens/Survey/Satisfaction/questions.json";
import questions from "../../../screens/Survey/Questions/questions.json";
import Individual from "./Individual";

class SatisfactionSurvey extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading: true,
            surveys: [],
            individual: false
        }

        this.handleState = this.handleState.bind(this);
        this.getSurveys = this.getSurveys.bind(this);
        this.getData = this.getData.bind(this);
        this.onDeleteFeedback = this.onDeleteFeedback.bind(this);
    }
    componentDidMount(){
        this.getSurveys();
    }
    handleState(data){
        this.setState(data);
    }
    onDeleteFeedback(record){
        const 
            { firebase, event } = this.props,
            self = this;

        swal({
            title: "",
            text: "Se eliminará esta retroalimentación, ¿Estas seguro?",
            icon: "warning",
            buttons: true,
            dangerMode: true
        })
        .then((willDelete) => {
            if (willDelete) {
                self.setState({isLoading: true}, ()=>{
                    firebase.subCollection.delete("events", event.id, "feedback", record.id)
                    .then(()=>{
                        swal("", "La encuesta ha sido eliminada", "success");
                        const {surveys = []} = self.state;
                        for(let i = 0; i < surveys.length; i++){
                            if (surveys[i].id === record.id){
                                surveys.splice(i, 1);
                                self.getData(surveys);
                                break;
                            }
                        }
                    });
                });
            }
        });
    }
    getSurveys(){
        const 
            { firebase, event } = this.props,
            self = this;

        firebase.subCollection.get("events", event.id, "feedback")
        .then((response)=>{
            if (response.empty){
                self.setState({isLoading: false});
            } else{
                this.getData(response, true);
            }
        });

    }
    getData(response, fromFirebase = false){
        const surveys = [];

        let
            satisfaction_ratio = 0,
            satisfaction_questions = {},
            survey_questions = {},
            avg_time = 0,
            completes = 0,
            nps = 0,
            promotor = 0,
            detractor = 0,
            passive = 0,
            size = 0,
            mobileCount = 0;

        response.forEach((doc) => {
            let data = doc;
            size++;

            
            if (fromFirebase){
                data = doc.data();
            }

            if (data.isMobile){
                mobileCount++;
            }

            if (!isNaN(data.findings)) {
                nps++;
                data.findings = data.findings - 1;
                if (data.findings < 7) {
                    detractor++;
                } else{
                    if (data.findings > 8) {
                        promotor++;
                    } else{
                        passive++;
                    }
                }

            }
            surveys.push({ 
                ...data, 
                id: doc.id, 
                status: (data.endDate ? "COMPLETA" : "INCOMPLETA"),
                time: (data.endDate ? data.endDate : data.endSatisfaction) - data.startDate 
            });

            if (data.endDate) {
                completes++;
            }

            satisfaction_ratio += data.avg;
            satisfactionQuestions.forEach((question) => {
                if (isNaN(data[question.value])){
                    data[question.value] = 0;
                }
                if (satisfaction_questions[question.value] === undefined) {
                    satisfaction_questions[question.value] = data[question.value];
                } else {
                    satisfaction_questions[question.value] = (satisfaction_questions[question.value] + data[question.value]) / 2;
                }
            });

            questions.forEach((question) => {
                if (survey_questions[question.value] === undefined) {
                    survey_questions[question.value] = 0;
                }

                if (data[question.value]) {
                    survey_questions[question.value] += 1;
                }
            });

            if (data.endDate) {
                if (avg_time > 0) {
                    avg_time = (data.endDate - data.startDate)
                } else {
                    avg_time += (data.endDate - data.startDate) / 2;
                }
            }
        });

        nps = {
            total: nps,
            promotor,
            detractor,
            passive
        }

        surveys.sort((a, b) => {
            if (a.startDate > b.startDate) {
                return 1
            }
            if (a.startDate < b.startDate) {
                return -1
            }
            return 0;
        });

        

        const dates = {};
        surveys.forEach((survey) => {
            const day = moment.unix(survey.startDate).format("YYYY-MM-DD");
            if (dates[day] === undefined) {
                dates[day] = 1;
            } else {
                dates[day] += 1;
            }
        });

        satisfaction_ratio = (satisfaction_ratio / size);

        this.setState({
            isLoading: false,
            surveys,
            dates_data: dates,
            satisfaction_ratio,
            satisfaction_questions,
            survey_questions,
            avg_time,
            completes,
            nps,
            mobileCount
        });
    }
    render(){
        if (this.state.individual){
            return <Individual data={this.state.individualData} handleState={this.handleState}/>
        }
        return (
            <View {...this.state} event={this.props.event} handleState={this.handleState} onDeleteFeedback={this.onDeleteFeedback} />
        )
    }
}

export default SatisfactionSurvey;